import { HomeLinkButton } from '../../../components/QuizPersonalApplication/components/HomeLinkButton/HomeLinkButton';

export const extraBtnsMap = {
  mainPage: HomeLinkButton,
};
